import { Component } from '@angular/core';
import { ConfigService } from 'src/app/services/config.service';

@Component({
  selector: 'app-chatia',
  templateUrl: './chatia.component.html',
  styleUrls: ['./chatia.component.scss']
})
export class chatiacomponent {

  mostrarChat = false;
  iframeChat: string;

  overlay: HTMLDivElement | null = null;

  constructor(private configService: ConfigService) {
    this.iframeChat = this.configService.config.urlchatIAfinance;
  }

  onButtonClick(): void {
    this.mostrarChat = !this.mostrarChat;
  }


  cerrarChat(): void {
    this.mostrarChat = false;
  }
  onDragStarted(): void {
    // Creamos overlay para capturar eventos sobre iframe mientras arrastramos
    this.overlay = document.createElement('div');
    this.overlay.style.position = 'fixed';
    this.overlay.style.top = '0';
    this.overlay.style.left = '0';
    this.overlay.style.width = '100vw';
    this.overlay.style.height = '100vh';
    this.overlay.style.zIndex = '9998';
    this.overlay.style.cursor = 'grabbing';
    document.body.appendChild(this.overlay);
  }

  onDragEnded(): void {
    // Eliminamos overlay cuando termina el arrastre
    if (this.overlay) {
      document.body.removeChild(this.overlay);
      this.overlay = null;
    }
  }
}
